// src/utils/presence.ts — SCE Issues
// « Apparaître non connecté » (26/10) : la personne ne signale plus sa présence
// (ni pile d'avatars, ni « consulte aussi cette fiche ») mais voit toujours qui
// est là. Réglage rangé dans le bloc `presence` de SA ligne de SCE_UserPrefs :
// il la suit d'un appareil à l'autre. Une copie locale le connaît dès
// l'ouverture, avant la lecture de SharePoint — sans elle, un premier
// battement partirait avant qu'on sache qu'il ne fallait pas. Pur, testable.

export const CLE_BLOC_PRESENCE = 'presence'

export interface ReglagePresence {
  invisible: boolean
}

/** Lecture tolérante du bloc : tout ce qui n'est pas `invisible: true` = visible. */
export function lireReglagePresence(brut: unknown): ReglagePresence {
  return { invisible: typeof brut === 'object' && brut !== null && (brut as { invisible?: unknown }).invisible === true }
}

export const cleCopieLocale = (upn: string): string => `sce-issues:presence-invisible:${upn.trim().toLowerCase()}`

/** Signaler un battement ? Jamais en invisible, ni tant que le réglage n'est pas connu. */
export const doitSignaler = (invisible: boolean | null): boolean => invisible === false
